import dayjs from "dayjs";
import { Card, CardContent, Typography } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import { DatamateAuditEventModel } from "@/pages/mcp/mcpSlice";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@altimateai/lego";
import { getIntegrationIcon } from "./utils";

const DatamateHistory = ({ events }: { events: DatamateAuditEventModel[] }) => {
  const getDetailsText = ({ event_type, payload }: DatamateAuditEventModel) => {
    if (payload["args"]) {
      return JSON.stringify(payload["args"], null, 2);
    }

    if (event_type === "guard_rail" && payload["masking_type"] && payload["mask"]) {
      return `Output contains ${payload["masking_type"]} pattern (${payload["mask"]})`;
    }

    return null;
  };

  return (
    <div>
      <Typography variant="h4" className="al-mb-6">
        Activity History
      </Typography>
      <Card>
        <CardContent>
          <div className="al-divide-y al-divide-gray-100">
            <Accordion type="single" collapsible className="al-w-full">
              {events.map((item, index) => {
                const detailsText = getDetailsText(item);
                return (
                  <AccordionItem key={index} value={`item-${index}`}>
                    <AccordionTrigger className="al-text-left hover:al-no-underline">
                      <Stack gap="xl">
                        <Stack
                          direction="row"
                          className="al-w-8 al-h-8 al-m-4"
                          align="center"
                          justify="center"
                        >
                          {getIntegrationIcon(item.integration_id)}
                        </Stack>
                        <Stack align="center" justify="center">
                          <span className="al-text-gray-400 al-text-sm al-flex-1">
                            {dayjs(item.timestamp).format("h:mm A, MMM D, YYYY")}
                          </span>
                        </Stack>
                        <Stack align="center" justify="center">
                          <span className="al-p-2 al-rounded-xl al-bg-blue-50 al-text-blue-500">
                            {item.tool_name}
                          </span>
                        </Stack>
                        {item.payload["connection"]?.name && (
                          <Stack align="center" justify="center">
                            <span className="al-p-2 al-rounded-xl al-bg-green-50 al-text-green-500">
                              Connection: {item.payload["connection"]?.name}
                            </span>
                          </Stack>
                        )}
                        {item.payload["connection"]?.is_remote && (
                          <Stack align="center" justify="center">
                            <span className="al-p-2 al-rounded-xl al-bg-yellow-50 al-text-yellow-500">
                              Connection type:{" "}
                              {item.payload["connection"]?.is_remote ? "Remote" : "Local"}
                            </span>
                          </Stack>
                        )}
                      </Stack>
                    </AccordionTrigger>

                    {detailsText && (
                      <AccordionContent>
                        <pre className="al-bg-[#1e1e1e] al-text-[#d4d4d4] al-font-mono al-text-xs al-p-4 al-rounded-md al-overflow-x-auto al-whitespace-pre-wrap al-ml-[50px]">
                          {detailsText}
                        </pre>
                      </AccordionContent>
                    )}
                  </AccordionItem>
                );
              })}
            </Accordion>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default DatamateHistory;
